
const getParsedDependencies = (dependenciesString) => {
    try {
        const dependencies = JSON.parse(dependenciesString) || {}

        // Some dependencies were created with the 'custom.' prefix, have to remove it
        // to keep the field name consistent in dependencies
        if(dependencies.field) dependencies.field = dependencies.field.replace('custom.', '')
        
        return dependencies

    } catch (e) {
        return undefined
    }
}


export { getParsedDependencies }